import styled from 'styled-components'

/** Building block for left-hand Detail label */
const Term = styled.dt`
  color: ${({ theme }) => theme.dimWhite};
  margin-top: 25px;
  font-size: 14px;

  @media only screen and (min-width: 768px) {
    flex: 1 1 180px;
    padding-right: 20px;
  }
`

/** Building block for right-hand Detail components */
const Definition = styled.dd`
  flex: 1 1 calc(100% - 180px);
  margin-top: 6px;
  margin-left: 0;
  font-size: 14px;

  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
  -ms-hyphens: auto;
  -moz-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;

  @media only screen and (min-width: 768px) {
    margin-top: 25px;
  }
`

/** Container for Details
 * `Detail.Term` - Left hand label
 * `Detail.Definition` - Right Hand content block
 * `Detail.Paragraph` - Styling for simple text Definition
 * `Detail.List` - Styling for using an unordered list in a Definition
*/
const Details = styled.dl`
flex-direction: row;
flex-wrap: wrap;
margin-right: 12px;

${Term}:first-of-type {
  margin: 0;
}

${Definition} {
  :first-of-type {
    margin: 0;
  }
  
  + ${Definition} {
    flex: 1 1 100%;
    padding-left: 120px;
  }
}

@media only screen and (min-width: 768px) {
  display: flex;
}
`

Details.Term = Term
Details.Definition = Definition

export default Details
